import * as React from 'react'
import { MenuListProps, components } from 'react-select'
import { TUpdateOption } from '../search-result-type-select.types'

export const MenuList = (props: MenuListProps<TUpdateOption, false>) => (
  <components.MenuList {...props} className="py-0 max-h-[250px]" />
)
